'use client';

import { useToast } from '@/components/ui/use-toast';
import { openCartClearConfirmation } from '@/store/cart/cart-clear-confirmation.store';
import { ensureCartLoaded, getCartClearReason } from '@/store/cart/cart.store';
import { CartAddIntent } from '@/types/cart-clear-confirmation.types';
import { trackCartClearAnswer, trackCartClearConfirmationShown } from '@/utils/cart/cart-analytics.util';

export const CART_READ_ERROR_MESSAGE = 'Não foi possível verificar seu carrinho. Tente novamente.';

export interface UseCartClearConfirmationResult {
  confirmCartClear: (intent: CartAddIntent) => Promise<boolean>;
}

export function useCartClearConfirmation(): UseCartClearConfirmationResult {
  const { toast } = useToast();

  async function confirmCartClear(intent: CartAddIntent): Promise<boolean> {
    const { cart, wasRead } = await ensureCartLoaded();

    if (!wasRead) {
      toast.error(CART_READ_ERROR_MESSAGE);

      return false;
    }

    const reason = getCartClearReason(cart, intent);

    if (!reason) {
      return true;
    }

    const cartItems = cart?.items ?? [];

    trackCartClearConfirmationShown(reason, cartItems);

    const confirmed = await openCartClearConfirmation(reason);

    trackCartClearAnswer(reason, confirmed, cartItems);

    return confirmed;
  }

  return { confirmCartClear };
}
